import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  Input, ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {ReportProfile} from '../../../../model/archive/report-profile';
import {FormFieldConfig} from '../../../../model/api/form-field-config';
import {CcBaseComponent} from "../../../../crystal-elements/cc-base.component";
import {TableColumnConfig} from "../../../../model/api/table-column-config";
import {TableRequest} from "../../../../model/api/table-request";
import {TableButtonConfig} from "../../../../model/api/table-button-config";
import {ReportTask} from "../../../../model/archive/report-task";
import {FormFieldGroupConfig} from "../../../../model/api/form-field-group-config";
import {AllocationTask} from "../../../../model/clearing/allocation/allocation-task";
import {AllocationTaskLoadRequest} from "../../../../model/clearing/allocation/allocation-task-load-request";
import {ClearingAllocationTaskService} from "../../../../services/clearing/clearing-allocation-task.service";
import {CcTableComponent} from "../../../../crystal-elements/table/cc-table.component";
import {AppConfigService} from "../../../../services/app-config.service";
import {EMPTY, exhaustMap, takeUntil, timer} from "rxjs";
import {catchError, filter} from "rxjs/operators";

@Component({
  selector: 'app-allocation-tasks-table',
  templateUrl: './allocation-tasks-table.component.html',
  styleUrls: ['./allocation-tasks-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AllocationTasksTableComponent extends CcBaseComponent {


  tableConfig: TableColumnConfig[] = [];

  headerButtonConfig: TableButtonConfig[] = [];

  contextMenuConfig: MenuItem[] = [];
  formRecord: AllocationTask;
  selectedRecords: AllocationTask;
  records: AllocationTask[] = [];
  recordsChange = new EventEmitter<AllocationTask[]>();

  totalRecords: number = 0;
  inProgressCount: number = 0;

  tableLoading: boolean = true;
  forceReload: boolean = true;

  tableCurrentRequest: AllocationTaskLoadRequest;
  tableCurrentRequestChange = new EventEmitter<TableRequest>();

  states = [
    AllocationTask.STATE.TREATED, AllocationTask.STATE.ERROR, AllocationTask.STATE.IN_PROGRESS];
  @Input()
  transPartKey: string;
  @Input()
  visible: boolean = true;
  selectedProfile: ReportProfile;
  formConfig: FormFieldGroupConfig[];
  detailDialogVisible: boolean;
  private reloadAllocSub?: any;

  @ViewChild('ccTable')
  public ccTable: CcTableComponent;

  constructor(cdref: ChangeDetectorRef,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              private allocationTaskService: ClearingAllocationTaskService,
              private appConfigService: AppConfigService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);

  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    setTimeout(() => {
      this.startReloadAllocationRecordsLoop();
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  protected initConfigs() {
    super.initConfigs();

    function getRowClass(record: AllocationTask) {
      if (AllocationTask.STATE.TREATED === record.state)
        return "task-treaded";
      else if (AllocationTask.STATE.ERROR === record.state)
        return "task-error";
      else if (AllocationTask.STATE.IN_PROGRESS === record.state)
        return "task-inprogress";
    }

    this.tableConfig = [
      {
        field: 'creationDate',
        format: 'dd/MM/yyyy HH:mm:ss',
        type: 'DATE',
        class: record => getRowClass(record),
        notFilterable: true
      },
      // {
      //   field: 'modificationDate',
      //   width: 130,
      //   format: 'dd/MM/yyyy HH:mm:ss',
      //   type: 'DATE',
      //   class: record => getRowClass(record)
      // },
      {
        field: 'state',
        class: record => getRowClass(record)
      },
      {
        field: 'message',
        width: 200,
        toolTip: record => record.message,
        class: record => getRowClass(record)
      },
      {
        field: 'exchangeCode',
        class: record => getRowClass(record)
      },
      {
        field: 'type',
        class: record => getRowClass(record)
      },
      {
        field: 'itemCount',
        class: record => getRowClass(record)
      }]
    // if (this.isAdmin()) {
    this.tableConfig.push({
      field: 'ccOperator',
      class: record => getRowClass(record)
    });
    // }


    let simplified = !this.isAdmin();
    // this.headerButtonConfig = [
    //   {
    //     tooltip: this.translateService.instant('common.table.detail_button'),
    //     icon: 'fas fa-eye',
    //     class: ' p-button-success',
    //     command: records => this.showDialogForm(this.selectedRecords),
    //     enabled: () => this.selectedRecords && this.hasOneSelection()
    //   }
    // ];
    // this.contextMenuConfig = [
    //   {
    //     label: this.translateService.instant('common.table.detail_button'),
    //     icon: 'fas fa-eye',
    //     command: () => {
    //       this.showDialogForm(this.formRecord);
    //     }
    //   }
    // ];
    this.formConfig = [];
    // const groupFields = [];
    // if (!simplified) {
    //   groupFields.push({
    //     field: 'active',
    //     column: 2,
    //     type: TYPE.CHECKBOX,
    //   });
    // }
    // this.formConfig.push({
    //   group: '',
    //   fields: groupFields
    // });
    // groupFields.push({
    //     field: 'name',
    //     column: 3,
    //     type: TYPE.TEXT,
    //   },
    //   {
    //     field: 'title',
    //     column: 3,
    //     type: TYPE.TEXT,
    //   },
    //   {
    //     field: 'visibility',
    //     'required': true,
    //     column: 2,
    //     type: TYPE.TEXT,
    //   },
    //   {
    //     type: TYPE.NONE,
    //     column: 2,
    //   });
    // this.formConfig.push({
    //   group: 'template',
    //   fields:
    //     [{
    //       field: 'exportTemplate',
    //       'required': true,
    //       column: 3,
    //       type: TYPE.TEXT,
    //     },
    //       {
    //         field: 'exportFormat',
    //         'required': true,
    //         column: 3,
    //         type: TYPE.TEXT,
    //       },
    //       {
    //         field: 'exportDateMode',
    //         'required': true,
    //         column: 3,
    //         type: TYPE.TEXT,
    //       },
    //       {
    //         field: 'zipFile',
    //         column: 2,
    //         type: TYPE.CHECKBOX,
    //       },
    //       {
    //         type: TYPE.NONE,
    //         column: 1,
    //       },
    //       {
    //         field: 'filterMap',
    //         column: 12,
    //         type: TYPE.MAPFIELD
    //       }
    //     ]
    // })
    // if (!simplified) {
    //   this.formConfig.push({
    //       group: 'schedule',
    //       fields:
    //         [{
    //           field: 'executionTimesJS',
    //           column: 4,
    //           type: TYPE.MULTISELECT
    //         },
    //           {
    //             field: 'executionDaysOfMonthJS',
    //             column: 4,
    //             type: TYPE.MULTISELECT,
    //           }]
    //     },
    //     {
    //       group: 'transfer',
    //       fields:
    //         [{
    //           field: 'transferMailSubject',
    //           column: 4,
    //           type: TYPE.TEXT,
    //         },
    //           {
    //             field: 'transferMailTemplate',
    //             column: 3,
    //             type: TYPE.TEXT
    //           },
    //           {
    //             column: 5,
    //             type: TYPE.NONE,
    //           },
    //           {
    //             field: 'transferMailRecipients',
    //             column: 12,
    //             type: TYPE.MULTITEXT,
    //           },
    //           {
    //             field: 'transferFileLocations',
    //             column: 6,
    //             type: TYPE.MULTISELECT,
    //           }
    //         ]
    //     },
    //     {
    //       group: 'alert',
    //       fields:
    //         [{
    //           field: 'mailAlert',
    //           column: 3,
    //           type: TYPE.CHECKBOX
    //         }]
    //     });
    // }
  }

  // loadRecords(request ?: ReportTaskLoadRequest) {
  //   this.tableLoading = true;
  //   this.reLoadRecords(request);
  // }


  startReloadAllocationRecordsLoop(): void {
    const intervalMs = this.appConfigService.clearingAllocationTaskReloadInterval;

    // optional safety: only one loop
    this.reloadAllocSub?.unsubscribe();

    this.reloadAllocSub = timer(0, intervalMs)
      .pipe(
        takeUntil(this.destroy$),

        // wait until request exists
        filter(() => !!this.tableCurrentRequest),

        // one list() at a time, ignore ticks while request in flight
        exhaustMap(() =>
          this.allocationTaskService.list(this.tableCurrentRequest!).pipe(
            catchError(err => {
              this.errorMessage(String(err));
              this.tableLoading = false;
              this.markForCheck();
              return EMPTY;
            }),
          ),
        ),
      )
      .subscribe(tableRecordResult => {
        if (tableRecordResult.success) {
          if (this.forceReload || this.totalRecords !== tableRecordResult.total) {
            this.records.splice(0, this.records.length);
            this.forceReload = false;
          }

          this.totalRecords = tableRecordResult.total;
          this.inProgressCount = 0;

          this.applyRecordResult(
            tableRecordResult
          );

          this.records = [...this.records];
          this.recordsChange.emit(this.records);

          this.apiMessage(tableRecordResult);

          this.tableLoading = false;
          this.markForCheck();
        } else {
          this.errorMessage(tableRecordResult.message);
          this.tableLoading = false;
        }

        // refresh metadata (same as your original code)
        this.tableCurrentRequest!.syncMetadata = tableRecordResult.syncMetadata;
      });
  }

  // private applyRecordResult(tableRecordResult, from: number, to: number) {
  //   let hasChanged: boolean = false;
  //   tableRecordResult.records.forEach(newRecord => {
  //     const recordIndex = this.records.findIndex(record => record.id === newRecord.id);
  //     if (recordIndex >= 0) {
  //       for (let key in newRecord) {
  //         this.records[recordIndex][key] = newRecord[key];
  //       }
  //     } else {
  //       this.records.splice(0, 0, newRecord);
  //       hasChanged = true;
  //     }
  //   });
  //   return hasChanged;
  // }

  private applyRecordResult(tableRecordResult): boolean {
    const changed =
      JSON.stringify(this.records.map(r => r.id))
      !== JSON.stringify(tableRecordResult.records.map(r => r.id));

    if (changed) {
      this.records = [...tableRecordResult.records];
      return true;
    }

    tableRecordResult.records.forEach((newRecord, i) => {
      Object.assign(this.records[i], newRecord);
    });

    return false;
  }

  hasOneSelection(): boolean {
    return this.selectedRecords != undefined;
  }

  onRowDblClick($event: any) {
    // if (this.isAdmin())
    // this.showDialogForm(this.selectedRecords);
  }

  showDialogForm(record: AllocationTask): void {
    this.selectedProfile = Object.assign({}, JSON.parse(record.allocationParametersJson));
    this.detailDialogVisible = true;
  }

  closeDialogForm(): void {
    this.detailDialogVisible = false;
  }

  needLoadRecords(request: AllocationTaskLoadRequest) {
    this.tableLoading = true;

    if (this.tableCurrentRequest && ((this.tableCurrentRequest.filters.length === 0 && request.filters.length > 0)
      || (JSON.stringify(this.tableCurrentRequest.filters) != JSON.stringify(request.filters))
      || (this.tableCurrentRequest.sortField !== request.sortField)
      || (this.tableCurrentRequest.sortOrder != request.sortOrder)
      || (this.tableCurrentRequest.globalFilter !== request.globalFilter))) {
      this.totalRecords = 0;
      this.forceReload = true;
    }
    if (request) {
      this.tableCurrentRequest = request;
      this.tableCurrentRequest.states = this.states;
    }
    if (this.tableCurrentRequest && !this.tableCurrentRequest.sortOrder) {
      this.tableCurrentRequest.sortOrder = 1;
      this.tableCurrentRequest.sortField = 'id';
    }
  }
}
